export const DEFAULT_SUPPORT_CONTACT_EMAIL = 'support@app.supply-guard.io';
export const SUPPORT_CONTACT_PLATFORM_SETTING_KEY = 'support_contact';

export interface SupportContact {
  email: string;
}

const isEmailLike = (value: string) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);

const parseJsonString = (value: string): unknown => {
  try {
    return JSON.parse(value);
  } catch {
    return value;
  }
};

export const resolveSupportContact = (value: unknown): SupportContact => {
  if (typeof value === 'string') {
    const trimmed = value.trim();
    const parsed = trimmed.startsWith('{') ? parseJsonString(trimmed) : trimmed;

    if (typeof parsed === 'string' && isEmailLike(parsed)) {
      return { email: parsed };
    }

    if (parsed && typeof parsed === 'object' && 'email' in parsed) {
      const email = String(parsed.email ?? '').trim();
      if (isEmailLike(email)) {
        return { email };
      }
    }
  }

  if (value && typeof value === 'object' && 'email' in value) {
    const email = String((value as { email?: unknown }).email ?? '').trim();
    if (isEmailLike(email)) {
      return { email };
    }
  }

  return { email: DEFAULT_SUPPORT_CONTACT_EMAIL };
};

export const buildSupportMailto = (email: string, subject: string, body?: string) => {
  const params = new URLSearchParams();
  params.set('subject', subject);

  if (body) {
    params.set('body', body);
  }

  return `mailto:${email}?${params.toString()}`;
};
